import { BaseDataTransferObject } from '../base-data-transfer-object';

export enum TestType {
    Normal = 1,
    Ratio = 2,
    BillOnly = 4,
    Panel = 8,
    SuperPanel = 16, // 0x00000010
    Microbiology = 32, // 0x00000020
    Toxicology = 64, // 0x00000040
    ToxicologyRatio = 128, // 0x00000080
    Pathology = 256, // 0x00000100
    None = 512, // 0x00000200
    All = 0x000001FF
}

export class TestTest extends BaseDataTransferObject {
    public ownerId!: number;
    public childId!: number;
    public ordinalNumber!: number;
    public parentId!: number;
}

export class TreeTest extends BaseDataTransferObject {
    public code!: string;
    public name!: string;
    public type!: TestType;
    public alternateNames!: string;
    public parentId?: number;
    public children!: TestTest[];
  public isConfidential?: boolean;
}

